<div mat-dialog-title class="m-0">
    รายงานผล
    <div style="float: right; margin-top: -5px;">

        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()"
            style="float: right; margin-top: -6px;">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>

<!-- for share measure feature -->
<!-- <mat-dialog-content id="modalSelectReport" class="mat-typography">
    <div class="container py-4 wrapper-container">
        <div class="row d-flex justify-content-center">
            <div *ngIf="modalData.MEASURE_DONE" class="col-lg-8 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                <button class="btn btn-success my-2" (click)="myReport()">
                    ดูรายงานผลของฉัน
                </button>
            </div>
            <div *ngIf="modalData.ACCESS_VIEW === 1" class="col-lg-8 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                <button class="btn btn-outline-primary my-2" (click)="permission()">
                    คำขอการเข้าถึงรายงานผลของฉัน
                </button>
            </div>
            <hr *ngIf="modalData.IS_SHARE_MEASURE === 1 && modalData.ACCESS_VIEW === 1" style="background: #000; width:100%; margin: 10px 0;">
            <div *ngIf="modalData.IS_SHARE_MEASURE === 1"
                class="col-lg-8 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                <button class="btn other-report my-2" (click)="otherReport()">
                    ส่งต่อแบบทดสอบและดูรายงานผลของผู้อื่น
                </button>
            </div>
        </div>
    </div>
</mat-dialog-content> -->

<mat-dialog-content id="modalSelectReport" class="mat-typography">
    <div class="container py-5">
        <div class="row d-flex justify-content-center">
            <div class="col-lg-8 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                <button class="btn btn-success mb-4" (click)="myReport()">
                    ดูรายงานผลของฉัน
                </button>
            </div>

            <!-- for share measure feature -->
            <!-- <hr width="100%" style="background: #000;">
            <div class="col-lg-8 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                <button class="btn other-report mt-4" (click)="otherReport()">
                    ดูรายงานผลของผู้อื่น
                </button>
            </div> -->
        </div>
    </div>
</mat-dialog-content>